module.exports = __webpack_public_path__ + "img/23-about.95a7f816.jpg";